import { createSlice } from "@reduxjs/toolkit";

const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        messages: []
    },
    reducers: {
        // setMessage: (state, action) => {
        //     // first remove existing message
        //     state.messages = state.messages.slice(1);
        //     // Add new message
        //     state.messages = action.payload;
        // },
        showMessage: (state, action) => {
            state.messages = action.payload;
        },
        removeMessage: (state, action) => {
            state.messages.splice(action.payload.id, 1);
        },
        setAutoRemoveMessage: (state, action) => {
            state.messages = state.messages.slice(1)
        }
    }
});

export const { showMessage, removeMessage, setAutoRemoveMessage } = alertSlice.actions;

export default alertSlice.reducer;